import { Component } from '@angular/core';

@Component({
    templateUrl: './nav.component.html',
    selector: 'nav-main',
    styleUrls: [ './nav.component.scss' ]
})
export class NavComponent {

    act: number;

    constructor() {
    	this.act = 1;
    }


    menu(set) {
      this.act = set
    }

}


// WEBPACK FOOTER //
// /code/frontend/src/app/main/nav/nav.component.ts